export var SET_NAVIGATION = 'SET_NAVIGATION';
export var SET_NAVIGATION_SERVICES = 'SET_NAVIGATION_SERVICES';